import React from 'react'
import S from './styled'
import LoginForm from './loginForm'

const LoginPage = () => (
  <S.LoginContainer>
    <LoginForm />
  </S.LoginContainer>
)

export default LoginPage
